import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { ApiError } from "@/lib/apiError";

type RequestPasswordResetInput = { tenantSlug: string; email: string };
type RequestPasswordResetResponse = { message: string };

export function useRequestPasswordReset() {
  return useMutation<RequestPasswordResetResponse, ApiError, RequestPasswordResetInput>({
    mutationFn: async ({ tenantSlug, email }) => {
      // fix/auth-slug-in-url: slug rides in the URL for client-routing symmetry
      // with /api/t/{slug}/auth/login (the underlying service is multi-tenant
      // fan-out, so the slug is not used to scope the lookup).
      const resp = await apiClient.post<RequestPasswordResetResponse>(
        `/api/t/${encodeURIComponent(tenantSlug)}/auth/forgot-password`,
        { email },
      );
      return resp.data;
    },
  });
}
